<div *ngIf="canToggle" class="flex flex-col mb-4 px-6">
    <div class="flex items-center gap-3">
        <span class="text-sm font-medium text-secondary">Bloqueo de pago</span>
        <mat-slide-toggle
            color="warn"
            [checked]="paymentBlocked"
            [disabled]="isLoading || isSubmitting"
            (change)="onToggleChange($event)">
        </mat-slide-toggle>
        <span class="text-sm" [ngClass]="paymentBlocked ? 'text-warn' : 'text-hint'">
            {{ paymentBlocked ? 'Bloqueado' : 'Habilitado' }}
        </span>
        <mat-spinner *ngIf="isLoading || isSubmitting" [diameter]="18"></mat-spinner>
    </div>

    <fuse-alert
        class="mt-2"
        *ngIf="showAlert"
        [dismissed]="!showAlert"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alert.type"
        [@shake]="alert.type === 'error'">
        {{ alert.message }}
    </fuse-alert>
</div>
